/**
 * True when an href must render as a native `<a>` anchor instead of
 * react-aria's `Link`.
 *
 * External links (absolute URLs, mailto:, tel:) routed through react-aria's
 * `Link` run the href through the app router's `useHref`, which resolves an
 * absolute URL as a *relative* path and mangles it (e.g. `https://x.com/y` →
 * `/current/path/https:/x.com/y`). Internal hrefs should keep using
 * `AriaLink` so navigation stays client-side (via AriaRouterProvider in
 * Root.tsx) instead of reloading the whole app.
 *
 * Single source of truth for this split — used by `lib/base/buttons/button.tsx`
 * and `lib/base/page-layout/page-layout.tsx` (and any future link-rendering
 * component that must choose between `<a>` and `AriaLink`).
 */
export function isExternalHref(href: unknown): href is string {
  return typeof href === 'string' && /^(https?:|mailto:|tel:)/i.test(href);
}
